module.exports = __webpack_public_path__ + "static/media/smart-ice-logo.346cd06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/smart-ice-logo.png
// module id = 1015
// module chunks = 0